module.exports = __webpack_public_path__ + "static/media/ptv.ccd4924f.md";